// src/components/ui/IconButton.tsx
import { Link, LinkProps } from "react-router-dom";

type Props = Omit<LinkProps, "className" | "children"> & {
  label: string;            // a11y label
  icon: React.ReactNode;    // <Settings className="h-5 w-5" />
  className?: string;
};
export default function IconButton({ label, icon, className = "", ...rest }: Props) {
  return (
    <Link
      {...rest}
      aria-label={label}
      title={label}
      className={`p-2 rounded text-gray-700 hover:text-elani-blue hover:bg-gray-100 ${className}`}
    >
      {icon}
    </Link>
  );
}